if (document.body.id === "Home") {
	let carousel = document.getElementById("quality-features");
	let itemMap = [];
	let carouselItems = {};
	let currentIndex = 0;

	const updateActive = () => {
		carousel.querySelectorAll("[data-item].previous").forEach(item => item.classList.remove("previous"));

		carousel.querySelectorAll("[data-item].active").forEach(item => {
			item.classList.add("previous");
			item.classList.remove("active");
		});

		carouselItems[itemMap[currentIndex]].forEach(item => item.classList.add("active"));
	}

	carousel.querySelector(".arrows .prev").addEventListener("click", () => {
		currentIndex--;

		if (currentIndex < 0)
			currentIndex = itemMap.length - 1;

		updateActive();
	});

	carousel.querySelector(".arrows .next").addEventListener("click", () => {
		currentIndex++;

		if (currentIndex >= itemMap.length)
			currentIndex = 0;

		updateActive();
	});

	carousel.querySelectorAll("[data-item]").forEach(item => {
		let id = item.dataset.item;

		if (!(id in carouselItems)) {
			itemMap.push(id);
			carouselItems[id] = [];
		}

		carouselItems[id].push(item);
	});
}